import { Box, BoxProps } from '@primer/react';
import React from 'react';
import styles from "./DataGrid.module.css"
interface IFocusedCellProps extends BoxProps {
    onLostFocused?: () => void
}
const FocusedCell = (props: IFocusedCellProps) => {
    return (
        <Box
            sx={{ margin: "-0.5rem -0.75rem" }}
            {...props}
            onBlur={() => {
                // alert("x")
                props.onLostFocused?.()
            }}
            className={styles.focusedCell}
        >

        </Box>
    );
};

export default FocusedCell;